import React, { useState } from 'react';
import { ButtonUI, DeleteDialogUI, DialogUI, FileTabUI, FileUploadUI } from '../../Interface';
import { Box } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';

const CheckListAttachmentDialog = ({ valuesState }) => {
  const { values, setValues } = valuesState;
  const [deleteDialog, setDeletDialog] = useState(false);
  const [removeElement, setRemoveElement] = useState(null);

  const handleFilesChange = (files) => {
    const existingAttachments = Array.isArray(values.itemAttachment) ? values.itemAttachment : [];

    if (files.length > 0) {
      setValues((prev) => ({
        ...prev,
        itemAttachment: [...existingAttachments, ...files],
      }));
    } else {
      const oldOnes = existingAttachments.filter((att) => att?.name);

      setValues((prev) => ({
        ...prev,
        itemAttachment: oldOnes.length > 0 ? oldOnes : [],
      }));
    }
  };

  const hideDeleteDialog = () => {
    setDeletDialog(false);
  };

  const handleRemoveElement = () => {
    const updatedRow = {
      ...values,
      itemAttachment: (values.itemAttachment || []).filter((attachment) => attachment.id !== removeElement),
    };

    setValues(updatedRow);

    setRemoveElement(null);
    setDeletDialog(false);
  };

  const handleDelete = (data) => {
    setRemoveElement(data.id);
    setDeletDialog(true);
  };

  return (
    <>
      <FileUploadUI onFilesChange={handleFilesChange} />
      <Box mt="1rem">
        <FileTabUI
          savedFiles={values.itemAttachment?.filter((attach) => attach.name) ?? []}
          handleDelete={handleDelete}
        />
      </Box>
      <DeleteDialogUI
        handleRemoveElement={handleRemoveElement}
        show={deleteDialog}
        onHide={() => {
          hideDeleteDialog();
          setRemoveElement(null);
        }}
      />
    </>
  );
};

export default CheckListAttachmentDialog;
